import { useTranslation } from 'react-i18next';

import type { Line } from '~/api/common/types';
import type { UserLanguage } from '~/api/user/types';

import { calculateLineDiscount, DocumentLineDescriptionCell } from '~/features/documents';
import { useIntl } from '~/hooks/useIntl';
import { clsx } from '~/styles/utils';

import { mobileRowStyle, mobileStyle, mobileTotalStyle } from './QuotationForClient.css';
import { useFormatQuantity } from './useFormatQuantity';

type Props = {
  language: UserLanguage;
  line: Line;
};

export const QuotationLineMobileCell = ({ language, line }: Props) => {
  const { formatCurrency } = useIntl(language);
  const formatQuantity = useFormatQuantity(language);
  const { t } = useTranslation(['lines']);

  return (
    <div className={mobileStyle}>
      <DocumentLineDescriptionCell line={line} />

      {line.type === 'entry' && (
        <>
          <div className={mobileRowStyle}>
            <span>
              {formatQuantity(line)} × {formatCurrency(line.price)}
            </span>
          </div>

          <div className={clsx(mobileRowStyle, mobileTotalStyle)}>
            <span>{t('lines:lineTotal.header')}</span>

            <span>{formatCurrency(line.quantity * line.price - calculateLineDiscount(line))}</span>
          </div>
        </>
      )}
    </div>
  );
};
